import { JSX, ChangeEvent, useCallback, useState } from "react";

import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";

import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

import { Role } from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type RoleInsertRowProps = {
	colSpan: number;

	isValid: (roleName: string) => boolean;
	onInsert: (role: Role) => void;
};

function RoleInsertRow(props: RoleInsertRowProps): JSX.Element {
	const [roleName, setRoleName] = useState("");

	const onUpdate = useCallback(
		(event: ChangeEvent<HTMLInputElement>): void => {
			setRoleName(event.target.value);
		},
		[]
	);

	const onInsert = useCallback((): void => {
		const role: Role = {
			name: roleName,
			informationRights: {},
			evaluationRights: [false, false],
			reportRights: {},
			adminRights: [false, false, false]
		};

		props.onInsert(role);
		setRoleName("");
	}, [roleName]);

	const onClear = useCallback((): void => {
		setRoleName("");
	}, []);

	return (
		<TableRow>
			<TableCell component="th" scope="row">
				<TextField
					required
					fullWidth
					value={roleName}
					onChange={onUpdate}
					variant="standard"
				/>
			</TableCell>
			<TableCell colSpan={props.colSpan} />
			<TableCell padding="none" align="right">
				<IconButton
					disabled={!props.isValid(roleName)}
					size="small"
					onClick={onInsert}>
					<CheckIcon fontSize="inherit" />
				</IconButton>
				<IconButton
					disabled={roleName === ""}
					size="small"
					onClick={onClear}>
					<ClearIcon fontSize="inherit" />
				</IconButton>
			</TableCell>
		</TableRow>
	);
}

export default RoleInsertRow;
